<template>
  <a :href="href" @click="goToComponent()">
    <dx-text :size="size" :weight="weight">
      <slot></slot>
    </dx-text>
    <dx-icon class="external-link" v-if="withIcon" icon="external-link"></dx-icon>
  </a>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';

library.add(faExternalLink);

export default {
  name: 'dx-link',
  props: {
    href: String,
    component: String,
    weight: String,
    size: String,
    withIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToComponent() {
      if (this.component !== undefined) {
        this.$router.push({ name: this.component });
      }
      if (this.href !== undefined) {
        this.$router.go(this.href);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  a {
    display: inline-block;
    text-decoration: none;
    color: #fff;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 1.0;
    }
  }

  .external-link{
    float: right;
    color: var(--dx-color--blue);
  }

  .loading * {
    pointer-events: none!important;
    cursor: wait !important;
    opacity: 0.8 !important;
  }
</style>
